import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1f8a9d1b&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8a9d1b')) {
      api.createRecord('1f8a9d1b', component.options)
    } else {
      api.reload('1f8a9d1b', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1f8a9d1b&", function () {
      api.rerender('1f8a9d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iGDHaPYP8nGo/JS/offershelp.vue"
export default component.exports